import styled from "styled-components";
import { Drawer } from "antd";

export const Container = styled(Drawer)`
  .ant-drawer-body {
    padding: 10px 0px 10px 0px;
  }

  .drawerForm {
    width: 100%;
    min-height: 600px;
    padding: 0px 24px;
  }

  .drawerFormCustom {
    width: 100%;
    height: 145px;
    padding: 0px 24px;
  }

  .rowLabel {
    margin-bottom: 7px;
    margin-top: 19px;
  }

  label {
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
    margin-left: 15px;
    margin-bottom: 7px;
    margin-top: 19px;
    &.error {
      color: #d44c4c;
    }
  }

  .rowInput {
    margin-top: 8px;
  }

  .tableButtonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button {
      display: flex;
      justify-content: center !important;
      text-align: center !important;
      align-items: center !important;
      font-size: 14px !important;
      width: 77px !important;
      height: 30px !important;

      svg {
        margin-right: 3px !important;
      }
    }

    button:first-of-type {
      width: 116px !important;
      margin-right: 12px !important;
    }
  }

  .ant-switch-checked {
    background-color: #a9c133 !important;
  }

  .resend {
    background: transparent;
    border: none;
    color: #A9C133 !important;
    font-size: 14px;
    cursor: pointer;
  }

  .hide {
    display: none;
  }

`;

export const AnimalsAmount = styled.div`
  height: 35px;
  border-radius: 17.5px;
  background: transparent;
  border: 1px solid #d44c4c;
  padding: 0 17px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    font-family: "Asap", sans-serif;
    font-size: 14px;
    color: #d44c4c;
  }

  span.number {
    font-size: 20px;
  }

  &.haveAnimals {
    background: #4a85ae;
    border: 1px solid #4a85ae;
    span {
      color: #fff;
    }

    span.number {
      font-size: 20px;
    }
  }
`;

export const Card = styled.div`
  height: 230px;
  width: 100%;
  padding: 0px 15px;
  border-radius: 6px;
  box-shadow: 0px 3px 6px #d8d8d8;

  img{
    margin: 0px auto;
  }

`;


export const CardItem= styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  width: 100%;
  padding: 15px;
  border-bottom: 1px solid #E2E2E2;
  color: black;

  &:hover {
    background: #f5f5f5;
  }
  
  span{
    margin-left: 10px;
    cursor: default;
  }

  svg {
    height: 16px;
    width: 16px;
    path {
      fill: #A5A5A5 !important;
    }
  }

  .ant-tooltip {
    max-width: 400px !important;
  }

  .new{
      padding-top: 25px;
      color: #c4c4c4;
      font-style: italic;
      font-size: 13px;
  }
`;